var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows,"id":_vm.id},domProps:{"value":_vm.value},on:{"change":_vm.change,"blur":_vm.blur}})
}
var staticRenderFns = []

export { render, staticRenderFns }